<script setup lang="ts">
import SessionParticipantInfoCard from '@/views/app/session/_components/toolbar/participants/SessionParticipantInfoCard.vue';
import { useSessionStore } from '@/stores/session.ts';
import { computed } from 'vue';
import { isNil } from '@/lib/utils.ts';

const sessionStore = useSessionStore();

const voters = computed(() => {
    return sessionStore.participants.filter((participant) => participant.role === 'voter');
});
const votesCount = computed(() => {
    return sessionStore.participants.filter((participant) => participant.role === 'voter' && !isNil(participant.vote))
        .length;
});
const observers = computed(() => {
    return sessionStore.participants.filter((participant) => participant.role === 'observer');
});
</script>

<template>
    <div class="flex flex-col gap-2">
        <div class="flex justify-between items-center px-4 py-2 paragraph-xs text-foreground-primary">
            <span class="font-normal">{{ voters.length }} Player{{ voters.length === 1 ? '' : 's' }}</span>
            <span class="font-bold">{{ votesCount }}/{{ voters.length }} Votes</span>
        </div>

        <div class="px-2 flex flex-col gap-2">
            <SessionParticipantInfoCard v-for="p in voters" :key="p.id" :user-id="p.id" variant="light" />
        </div>
        <div class="px-4 py-2 paragraph-xs text-foreground-primary">
            <span>{{ observers.length }} Observer{{ observers.length === 1 ? '' : 's' }}</span>
        </div>
        <div class="px-2 flex flex-col gap-2">
            <SessionParticipantInfoCard v-for="p in observers" :key="p.id" :user-id="p.id" variant="light" />
        </div>
    </div>
</template>
